<template>
  <v-app id="vuetify-app">
    <v-container fluid grid-list-md>
      <v-layout justify-space-between>
        <v-flex xs12 d-flex>
          <category-manage-modal/>
        </v-flex>
      </v-layout>
      <v-layout justify-space-between>
        <v-flex xs12 d-flex>
          <div>
            <ul>
              <li v-for="category in productCategories" :key="category.id">
                <product-category :product-category="category"/>
              </li>
            </ul>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
import {mapGetters, mapActions} from "vuex";

export default {
  data: function () {
    return {
      categories: [],
      productCategoryService: null,
    };
  },
  methods: {
    ...mapActions(['fetchProductCategories']),
  },
  created() {
    this.fetchProductCategories();
  },
  computed: {
    ...mapGetters(['productCategories']),
  },
}
</script>

<style scoped>

</style>
